module.exports = __webpack_public_path__ + "img/login_img.c68340c2.png";